/**
 * Created by JackCui on 2021/12/13
 */
export const tableSchemaHandle = {
  handle (node) {
    const {props} = node
    return {
      props: {
        ...props,
        span: '0'
      }
    }
  }
}

export const tableProps = {
  showGroupError: Function,
  // 全选方法
  changeAll: Function,
  // 全选
  isOpenAllCheck: {
    type: Boolean,
    default: false
  },
  // 表格列配置项
  columns: {
    type: Array,
    required: true
  },
  // 表格数据
  data: {
    type: Array,
    default: () => []
  },
  // 是否前端分页
  selfPaging: {
    type: Boolean,
    default: false
  },
  // 分页器配置项
  paginationOpt: {
    type: Object,
    default () {
      return {}
    }
  },
  // 请求函数
  fetch: Function,
  // 初始化时是否请求
  createGet: {
    type: Boolean,
    default: true
  },
  // 用于分组的key 相同的则为一组
  groupRowKey: {
    type: String,
    default: ''
  },
  groupKey: {
    type: String,
    default: ''
  },
  // 是否展示已选中
  selectedCount: {
    type: Number,
    default: 0
  },
  // rowKey
  rowKey: {
    type: String,
    default: ''
  },
  // 显示分页
  showPaginationOpt: {
    type: Boolean,
    default: true
  },
  defaultExpandAll: {
    type: Boolean,
    default: false
  },
  forceExpand: {
    type: Boolean,
    default: false
  },
  componentName: {
    type: String,
    default: 'FeTable'
  },
  groupHeight:{
    type: Object,
    default: () => ({})
  }
}

// event
// resetSelection
// toggleRowSelection
